<app-mat-spinner-overlay
  *ngIf="showWaitingForDataSpinner != 0"
  [overlay]="true"
>
</app-mat-spinner-overlay>

<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Definition und Anwendungsbereich</h4>
    </div>
  </div>
  <mat-card>
    <p>
      Mit der Anwendung lassen sich die betriebswirtschaftliche Ausrichtung und
      die wirtschaftliche Betriebsgröße von landwirtschaftlichen Betrieben für
      statistische und Fördermaßnahmen ermitteln.
    </p>

    <p>
      Die <b>betriebswirtschaftliche Ausrichtung (BWA)</b> beschreibt die
      Spezialisierungsrichtung eines Betriebes, z.B. spezialisierter
      Ackerbaubetrieb oder spezialisierter Milchviehbetrieb. Grundlage dafür ist
      der Anteil des Standardoutputs der einzelnen Betriebszweige am
      Gesamt-Standardoutput des Betriebes.
    </p>

    <p>
      Der <b>Gesamtstandardoutput eines Betriebs (Gesamt-SO)</b> errechnet sich
      aus dem Produktionsumfang seiner Merkmale multipliziert mit dem jeweiligen
      Standardoutput-Koeffizienten (SOC).
    </p>

    <p>
      Hierbei müssen entsprechend der Durchführungsverordnung (EU) 2019/1975 der
      Kommission vom 31. Oktober 2019 Sonderfälle bei der Bewertung von
      Jungtieren und Grundfutter berücksichtigt werden. Daher wird z.B. für
      rinderhaltende Betriebe neben der Summe der Standardoutputs der
      entsprechend korrigierte Wert „SO-Betrag bereinigt“ ausgewiesen. Die Summe
      der Spalte „SO-Betrag bereinigt“ entspricht der gesamten Standardoutput
      eines Betriebes.
    </p>

    <p>
      Ein Standardoutput-Koeffizient (SOC) bezeichnet den durchschnittlichen
      Wert der Bruttoerzeugung in einer bestimmten Region.
      Standardoutput-Koeffizienten werden in Euro je Hektar oder in Euro je Tier
      berechnet; für Geflügel in Euro je 100 Tiere und für Bienen in Euro je
      Bienenstock.
    </p>

    <p>
      Die Standardoutput-Koeffizienten (SOC) werden vom KTBL auf der Grundlage
      eines 5-jährigen Durchschnittes im Abstand von fünf Jahren ermittelt. Im
      aktuellen BWA-Rechner werden die Wirtschaftsjahre 2018 bis 2022
      herangezogen.
    </p>

    <p>
      Die <b>wirtschaftliche Betriebsgröße</b> ergibt sich aus dem
      Gesamt-Standardoutput (Gesamt-SO) eines Betriebes. Abhängig davon, wie
      hoch der Gesamt-SO ist, wird ein Betrieb zu einer bestimmten Größenklasse
      zugeordnet. Diese
      <a class="cursor-hover" (click)="openInTabBetriebsgroessenklassen()"
        >wirtschaftlichen Betriebsgrößenklassen
        <fa-icon [icon]="faUpRightFromSquare" class="ml-1"></fa-icon
      ></a>
      sind in der
      <a class="cursor-hover" (click)="openInTabVerordnung()"
        >Durchführungsverordnung (EU) 2019/1975
        <fa-icon [icon]="faUpRightFromSquare" class="ml-1"></fa-icon
      ></a>
      der Kommission vom 3. Februar 2015 mit Durchführungsbestimmungen zur
      Verordnung (EG) Nr. 1217/2009 des Rates zur Bildung eines
      Informationsnetzes landwirtschaftlicher Buchführungen über die
      Einkommenslage und die betriebswirtschaftlichen Verhältnisse
      landwirtschaftlicher Betriebe in der Europäischen Union definiert. Eine
      wirtschaftliche Betriebsgröße von 450.000 Euro z.B. ergibt die
      Größenklasse „IX (250.000 bis 499.999 Euro)“.
    </p>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
